import { useContext, useEffect, useState } from "react";
import { PitchContext } from "../context/PitchContex";
import PitchItem from "./../components/PitchItem";
import SearchBar from "../components/SearchBar";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import axios from "axios";

function Pitches() {
  const { pitches, search, setSearch, getAllPitches, setPending } =
    useContext(PitchContext);
  const [filterPitches, setFilterPitches] = useState([]);
  const [surfaces, setSurfaces] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [sortType, setSortType] = useState("relavent");
  const [showFilter, setShowFilter] = useState(false);

  const toggleSurface = (e) => {
    const value = e.target.value;
    setSurfaces((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  useEffect(() => {
    document.title = "Halısaha Kirala | Halısaha Bul";
  }, []);

  const toggleAmenities = (e) => {
    const value = e.target.value;
    setAmenities((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const applyFilter = () => {
    let copyFilter = pitches.slice();
    if (search) {
      copyFilter = copyFilter.filter((item) =>
        item.location.address.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (surfaces.length > 0) {
      copyFilter = copyFilter.filter((item) =>
        surfaces.includes(item.surfaceType)
      );
    }
    if (amenities.length > 0) {
      copyFilter = copyFilter.filter((item) =>
        amenities.every((amenity) => item.amenities.includes(amenity))
      );
    }
    setFilterPitches(copyFilter);
  };

  const applySort = () => {
    const fpCopy = filterPitches.slice();
    switch (sortType) {
      case "low-high":
        setFilterPitches(fpCopy.sort((a, b) => a.price - b.price));
        break;
      case "high-low":
        setFilterPitches(fpCopy.sort((a, b) => b.price - a.price));
        break;
      case "star":
        setFilterPitches(fpCopy.sort((a, b) => b.rating - a.rating));
        break;
      default:
        applyFilter();
        break;
    }
  };

  const resetFilters = () => {
    setSurfaces([]);
    setAmenities([]);
    setSearch("");
    setSortType("relavent");
    setFilterPitches(pitches);
  };

  useEffect(() => {
    applySort();
  }, [sortType]);

  useEffect(() => {
    applyFilter();
  }, [surfaces, amenities, search, pitches]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllPitches();
  }, []);

  return (
    <section className="py-16 max-w-7xl mx-auto">
      {/* Header */}
      <div className="text-center mb-12">
        <header>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight">
            Senin İçin En İyi Sahayı Kirala
          </h1>
        </header>
        <p className="text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed">
          Modern ve yüksek kaliteli sahalarımızla tanışın.
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* Filters Sidebar */}
        <aside className="w-full lg:w-1/4">
          {/* Mobile Filter Toggle */}
          <div
            className="lg:hidden flex items-center justify-between  p-4 bg-white shadow-sm rounded-xl cursor-pointer transition-all hover:shadow-md"
            onClick={() => setShowFilter((prev) => !prev)}
          >
            <h2 className="text-xl font-semibold text-gray-900">Filtreler</h2>
            <div className="p-2 bg-gray-100 rounded-full transition-transform">
              {showFilter ? (
                <IoIosArrowDown className="text-gray-700 w-5 h-5" />
              ) : (
                <IoIosArrowForward className="text-gray-700 w-5 h-5" />
              )}
            </div>
          </div>

          {/* Filter Content */}
          <div
            className={`${
              showFilter ? "block" : "hidden"
            } lg:block bg-white p-6 rounded-xl shadow-sm transition-all duration-300`}
          >
            {/* Surface Type Section */}
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Yüzey Tipi
              </h3>
              <div className="space-y-4">
                {["Doğal", "Yapay"].map((surface) => (
                  <label
                    key={surface}
                    className="flex items-center gap-3 cursor-pointer group"
                  >
                    <input
                      type="checkbox"
                      value={surface}
                      onChange={toggleSurface}
                      checked={surfaces.includes(surface)}
                      className="w-5 h-5 text-[#6ca87e] border-gray-300 rounded transition-all"
                    />
                    <span className="text-gray-700 group-hover:text-[#6ca87e] transition-colors">
                      {surface}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {/* Amenities Section */}
            <div className="mb-8 ">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Olanaklar
              </h3>
              <div className="grid grid-cols-1 gap-4 max-h-64 overflow-y-auto">
                {[
                  "Soyunma Odaları",
                  "Duşlar",
                  "Tuvaletler",
                  "Otopark",
                  "Oturma Alanı",
                  "Kafeterya",
                  "WiFi",
                  "İlk Yardım",
                  "Kilitli Dolaplar",
                  "Hakem Hizmetleri",
                  "Skor Tahtası",
                  "Çocuk Oyun Alanı",
                  "Takım Kulübeleri",
                  "Etkinlik Odası",
                  "Klima",
                ].map((amenity) => (
                  <label
                    key={amenity}
                    className="flex items-center gap-3 cursor-pointer group"
                  >
                    <input
                      type="checkbox"
                      value={amenity}
                      onChange={toggleAmenities}
                      checked={amenities.includes(amenity)}
                      className="w-5 h-5 text-[#6ca87e] border-gray-300 rounded  transition-all"
                    />
                    <span className="text-gray-700 group-hover:text-[#6ca87e] transition-colors">
                      {amenity}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {/* Reset Filters Button */}
            <button
              className="w-full bg-gray-100 text-gray-900 py-3 rounded-lg font-medium hover:bg-gray-200 transition-all duration-200 cursor-pointer"
              onClick={resetFilters}
            >
              Filtreleri Sıfırla
            </button>
          </div>
        </aside>

        {/* Pitches Content */}
        <main className="w-full lg:w-4/4">
          <div className="mb-8 flex flex-col sm:flex-row justify-between items-center gap-6">
            <div className="w-full sm:w-1/4 relative">
              <select
                className="w-full appearance-none bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm transition-all"
                onChange={(e) => setSortType(e.target.value)}
                value={sortType}
              >
                <option value="relavent">Önerilen</option>
                <option value="low-high">Fiyat: Düşükten Yükseğe</option>
                <option value="high-low">Fiyat: Yüksekten Düşüğe</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <svg
                  className="w-5 h-5 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
            <div className="flex justify-center w-full sm:w-1/2">
              <SearchBar />
            </div>
          </div>

          {filterPitches.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filterPitches.map((item) => (
                <div
                  key={item._id}
                  className="w-full rounded-xl  transition-all duration-300 flex justify-center"
                >
                  <PitchItem
                    id={item._id}
                    name={item.name}
                    slug={item.slug}
                    location={`${item.location.city}`}
                    price={item.price}
                    status={item.status}
                    image={item.images[0]}
                    bestSeller={item.bestSeller}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-16 bg-white rounded-xl shadow-sm">
              <h2 className="text-2xl font-semibold text-gray-900">
                Kriterlerinize uygun saha bulunamadı
              </h2>
              <p className="text-gray-500 mt-2">
                Filtrelerinizi veya arama teriminizi ayarlamayı deneyin.
              </p>
            </div>
          )}
        </main>
      </div>
    </section>
  );
}

export default Pitches;
